export default "__VITE_ASSET__7f_AtpCn__"